import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a1b41ee2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a1b41ee2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b41ee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1b41ee2')) {
      api.createRecord('a1b41ee2', component.options)
    } else {
      api.reload('a1b41ee2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a1b41ee2&scoped=true", function () {
      api.rerender('a1b41ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/QuotationVIPCustomer/VIPCustomer/index.vue"
export default component.exports